import React from 'react';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export function isIconDefinition(value: any): value is IconDefinition {
  return value && value.prefix && value.iconName && value.icon;
}

export interface IconHelperProps extends Omit<FontAwesomeIconProps, 'icon'> {
  icon?: React.ReactNode | IconDefinition;
}

export function IconHelper({ icon }: IconHelperProps): React.ReactElement {
  if (!icon) {
    return <></>;
  }

  if (isIconDefinition(icon)) {
    return <FontAwesomeIcon icon={icon} />;
  }

  return <>{icon}</>;
}
